export default "__VITE_ASSET__CWVKNLiY__"